export enum ContractDirectApplyChannelName {
	SEEK_AUSTRALIA = "seekAustralia",
	INFOJOBS_SPAIN = "infoJobsSpain",
	INDEED_GLOBAL = "indeedGlobal",
	NAUKRI_GLOBAL = "naukriGlobal",
	LINKEDIN_GLOBAL = "linkedinGlobal",
}

export enum ContractDirectApplyPostingRequirementQuestionnaireType {
	TEXT = "text",
	CHOICE = "choice",
	MULTI_CHOICE = "multi-choice",
}

export enum ContractDirectApplyPostingRequirementQuestionnaireLengthRule {
	MAX_LENGTH = "maxLength",
	MIN_LENGTH = "minLength",
}

export enum ContractDirectApplyPostingRequirementQuestionnaireOccursRule {
	MAX_OCCURS = "maxOccurs",
	MIN_OCCURS = "minOccurs",
}

export enum ContractDirectApplyPostingRequirementQuestionnaireQuestionCommonRule {
	MAX_QUESTIONS = "maxQuestions",
	HTML_ALLOWED = "htmlAllowed",
}

export enum ContractDirectApplyPostingRequirementQuestionnaireValidationWarningCode {
	CLOSED_QUESTION_ANSWER_MIN_LENGTH_WARNING = "closedQuestionAnswerMinLengthWarning",
	CLOSED_QUESTION_ANSWER_MAX_LENGTH_WARNING = "closedQuestionAnswerMaxLengthWarning",
	CLOSED_QUESTIONS_MAX_WARNING = "closedQuestionsMaxWarning",
	CLOSED_QUESTION_ANSWER_MAX_OCCURS_WARNING = "closedQuestionAnswerMaxOccursWarning",
	CLOSED_QUESTION_ANSWER_MIN_OCCURS_WARNING = "closedQuestionAnswerMinOccursWarning",
	CLOSED_QUESTION_NO_VALID_ANSWERS_WARNING = "closedQuestionNoValidAnswersWarning",
	CLOSED_QUESTION_SOME_ANSWERS_ARE_INVALID_WARNING = "closedQuestionSomeAnswersAreInvalidWarning",
	OPEN_QUESTIONS_MAX_WARNING = "openQuestionsMaxWarning",
	QUESTION_MIN_LENGTH_WARNING = "questionMinLengthWarning",
	QUESTION_MAX_LENGTH_WARNING = "questionMaxLengthWarning",
	QUESTIONS_MAX_TOTAL_WARNING = "questionsTotalMaxWarning",
}
